import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Route, UrlSegment, Router } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanLoad {

  constructor(private router: Router, private storage: LocalStorageService,) {}

  isAuthenticated(): boolean {
    const token =  this.storage.retrieve('token');
    if (token) {
      return true;
    }
    return false;
  }

  canActivate(): boolean {
    if (this.isAuthenticated()) {
      return true;
    }
    this.router.navigate(['/home']);   // redirect to home
    return false;
  }

  canLoad(): boolean {

    if (this.isAuthenticated()) {
      return true;
    }

    this.router.navigate(['/home']);   // redirect to home
    return false;
  }

}